import { useEffect, useCallback } from "react";
import { useAlert } from "../../../hooks/useAlert";

const AlertsSummaryComponent = ({ vmId, startDate, endDate }) => {
  const { getAlertSummary, summaryData, loading, error } = useAlert();

  useEffect(() => {
    if (vmId !== undefined && vmId !== null && startDate && endDate) {
      getAlertSummary(vmId, startDate, endDate);
    }
  }, [vmId, startDate, endDate]);

  if (loading) {
    return (
      <div className="bg-primary-dark rounded-xl border border-gray-700 p-6 h-full">
        <div className="text-center py-8">
          <div className="inline-block w-8 h-8 border-4 border-primary-cyan border-t-transparent rounded-full animate-spin"></div>
          <p className="text-gray-400 mt-3">Loading summary...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="bg-primary-dark rounded-xl border border-gray-700 p-6 h-full">
        <div className="text-center py-8">
          <p className="text-red-400">{error}</p>
        </div>
      </div>
    );
  }

  if (!summaryData) {
    return (
      <div className="bg-primary-dark rounded-xl border border-gray-700 p-6 h-full">
        <div className="text-center py-8">
          <p className="text-gray-400">Select a VM to view alerts</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-primary-dark rounded-xl border border-gray-700 p-6 h-full flex flex-col overflow-x-auto">
      <style>{`
        @media (max-width: 768px) {
          .alerts-summary-grid {
            grid-template-columns: repeat(3, 1fr) !important;
            gap: 8px !important;
          }
          .alerts-summary-card {
            padding: 8px !important;
            min-width: 0 !important;
          }
          .alerts-summary-card p:first-child {
            font-size: 12px !important;
          }
          .alerts-summary-card p:last-child {
            font-size: 18px !important;
          }
          .alerts-groups-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 8px !important;
          }
          .alert-group-item {
            padding: 8px !important;
            min-width: 0 !important;
          }
          .alert-group-item p:first-child {
            font-size: 12px !important;
          }
          .alert-group-item p:last-child {
            font-size: 18px !important;
          }
        }
        @media (max-width: 480px) {
          .alerts-summary-grid {
            gap: 6px !important;
          }
          .alerts-summary-card {
            padding: 6px !important;
          }
          .alerts-summary-card p:first-child {
            font-size: 10px !important;
          }
          .alerts-summary-card p:last-child {
            font-size: 16px !important;
          }
          .alerts-groups-grid {
            grid-template-columns: repeat(1, 1fr) !important;
          }
          .alert-group-item p:first-child {
            font-size: 11px !important;
          }
        }
      `}</style>
      <div className="flex justify-between items-center mb-4 pb-3 border-b border-gray-700 flex-shrink-0 flex-wrap gap-2">
        <h3 className="text-lg font-semibold text-white">Alerts Summary</h3>
        <span className="text-sm text-gray-400 break-all">{summaryData.vmName}</span>
      </div>

      <div className="grid grid-cols-3 gap-4 mb-6 flex-shrink-0 alerts-summary-grid">
        <div className="bg-gray-800 rounded-lg p-4 text-center py-12 alerts-summary-card">
          <p className="text-gray-400 text-xl font-bold">Total Alerts</p>
          <p className="text-white text-2xl font-bold">
            {summaryData.totalCount}
          </p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 text-center py-12 alerts-summary-card">
          <p className="text-gray-400 text-xl font-bold">Fired</p>
          <p className="text-white text-2xl font-bold">
            {summaryData.firedCount}
          </p>
        </div>
        <div className="bg-gray-800 rounded-lg p-4 text-center py-12 alerts-summary-card">
          <p className="text-gray-400 text-xl font-bold">Resolved</p>
          <p className="text-white text-2xl font-bold">
            {summaryData.resolvedCount}
          </p>
        </div>
      </div>

      <div className="flex-1 flex flex-col min-h-0">
        <p className="text-gray-400 text-sm mb-3 flex-shrink-0">Alert Groups</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 flex-1 content-start alerts-groups-grid">
          {summaryData.alertGroups.map((group) => (
            <div
              key={group.alertName}
              className="bg-gray-800 rounded-lg p-3 flex flex-col items-center justify-center h-full py-14 alert-group-item"
            >
              <p
                className="text-gray-400 text-xl font-bold text-center truncate w-full"
                title={group.alertName}
              >
                {group.alertName}
              </p>
              <p className="text-white text-2xl font-bold">{group.count}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AlertsSummaryComponent;